import { Platform } from 'react-native';

const TZ_KEY = 'rinsepay_timezone';

let cachedTimezone: string | null = null;

/** getTimezone - returns cached or detected user timezone, defaults to America/Chicago. */
export function getTimezone(): string {
  if (cachedTimezone) return cachedTimezone;
  if (Platform.OS === 'web' && typeof localStorage !== 'undefined') {
    cachedTimezone = localStorage.getItem(TZ_KEY);
  }
  return cachedTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Chicago';
}

/** setTimezone - updates cached timezone and persists to localStorage on web. */
export function setTimezone(tz: string) {
  cachedTimezone = tz;
  if (Platform.OS === 'web' && typeof localStorage !== 'undefined') {
    localStorage.setItem(TZ_KEY, tz);
  }
}

/** Parse a date string that may be SQLite format or ISO format */
export function parseDate(raw: string): Date {
  if (!raw) return new Date(NaN);
  const normalized = raw.includes('T') ? raw : raw.replace(' ', 'T') + 'Z';
  return new Date(normalized);
}

/** Format a date string for display using the user's timezone */
export function formatDateTime(raw: string): string {
  const d = parseDate(raw);
  if (isNaN(d.getTime())) return raw || 'Unknown';
  const tz = getTimezone();
  try {
    return d.toLocaleDateString('en-US', { timeZone: tz, month: 'short', day: 'numeric', year: 'numeric' }) + ' ' +
      d.toLocaleTimeString('en-US', { timeZone: tz, hour: 'numeric', minute: '2-digit' });
  } catch {
    // Fallback if timezone is invalid
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) + ' ' +
      d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  }
}

/** Common US timezones for the picker */
export const TIMEZONE_OPTIONS = [
  { label: 'Eastern (ET)', value: 'America/New_York' },
  { label: 'Central (CT)', value: 'America/Chicago' },
  { label: 'Mountain (MT)', value: 'America/Denver' },
  { label: 'Pacific (PT)', value: 'America/Los_Angeles' },
  { label: 'Alaska (AKT)', value: 'America/Anchorage' },
  { label: 'Hawaii (HT)', value: 'Pacific/Honolulu' },
  { label: 'Arizona (MST)', value: 'America/Phoenix' },
  { label: 'UTC', value: 'UTC' },
];
